import { newsletter } from './newsletter'
import { createInstagramFeed } from './instagram'
import { _t } from "../base";

function moveAddFooterElements() {
    $('#footer .social-icon-list').wrapAll('<div class="social-icons"></div>')

    $('#signature').wrapAll('<div class="signature-wrapper"></div>')

    // Add Able logo
    $('.footer-bottom .signature-wrapper').append(` <a href="https://able.cz" class="able-logo"></a> `)

    // $('#footer')
    //     .find('.copyright')
    //     .text(_t('footer.project'))
}

function contactSection() {
    $('.contact-box')
        .prepend(`<h2>${_t('contact.title')}</h2>`)
        .prependTo('.footer-rows')

    $('.contact-box .tel a').text($('.contact-box .tel').text())

    $(`<p>${_t('contact.hours')}</p>`).insertAfter('.contact-box .tel')
}

export function initFooter() {
    newsletter()
    createInstagramFeed()
    moveAddFooterElements()
    contactSection()
}
